module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-78e5cf4d"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 545
// module chunks = 1